import React, { useEffect, useState } from 'react';
import Header from '../Core/Header';
import Cookies from "js-cookie";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart, Bar,
} from "recharts";

import { useNavigate } from 'react-router-dom';
import { getAllDiagnosticRequest, getAllHospitalRequest, getPatientMapped } from '../../service/operations/api_methods';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';


const data2 = [
  { month: "Jan", profit: 1500, expenses: 900, patients: 50 },
  { month: "Feb", profit: 2200, expenses: 1200, patients: 170 },
  { month: "Mar", profit: 1800, expenses: 1400, patients: 1090 },
  { month: "Apr", profit: 3200, expenses: 2000, patients: 330 },
  { month: "May", profit: 5000, expenses: 2800, patients: 470 },
];


const data = [
  { name: 'Daily', admissions: 50 },
  { name: 'Weekly', admissions: 75 },
  { name: 'Monthly', admissions: 150 },
  { name: 'Yearly', admissions: 200 },
  { name: 'Year', admissions: 250 },
];


const Dashboard = () => {
  const [list, setList] = useState([])
  const [manage, setManage] = useState("")
  const navigate = useNavigate()
  const token = Cookies.get("token")
  const dispatch = useDispatch();

    const[list1,setList1]=useState([])
      const[list2,setList2]=useState([])

  const handleGetMappedpatient = async () => {
    try {
      const res = await getPatientMapped(token)
      console.log(res.data.data);
      if (res.status === 200) {
        setList(res.data.data)
      }

    } catch (error) {
      console.log(error);

    }
  }

     const handleGetHospitalRequest=async()=>{
          try {
              const response=await getAllHospitalRequest()
              console.log("getAllHospitalRequest",response);
              if(response.status===200){
                  setList1(response.data.data)
              }
              
          } catch (error) {
              console.log(error);
              
          }
      }
  
          const handleGetDiagnosticRequest=async()=>{
          try {
              const response=await getAllDiagnosticRequest()
              console.log("getAllDiagnosticRequest",response);
              if(response.status===200){
                  setList2(response.data.data)
              }
              
          } catch (error) {
              console.log(error);
              
          }
      }

  useEffect(() => {
    handleGetMappedpatient()
    handleGetHospitalRequest()
    handleGetDiagnosticRequest()

  }, [])

  return (
    <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
      <Header />
      <section style={{ marginTop: "80px", border: "1px solid black", width: "100%", height: "calc(100vh - 80px)", background: "linear-gradient(180deg, #93b8fcff, #ffffffff, #9bbdfdff)", padding: "10px", display: "flex", justifyContent: "space-between" }}>
        
        {/* SIDEBAR SECTION */}
        <div style={{ position: "relative", display: 'flex', flexDirection: "column", gap: "25px", width: "20%", background: "linear-gradient(90deg, rgb(255, 255, 255), #ffffffff)", padding: "16px", boxShadow: '10px 0 15px -5px rgba(0, 0, 0, 0.7)', borderRadius: "10px" }}>
          <p style={{ fontSize: "20px", backgroundColor: "#2a3ff7ff", padding: "8px", borderRadius: "6px", fontWeight: "700", color: "white", width: "90%", display: "flex", alignItems: "center", cursor: "pointer" }}>
            <img src='/Assets/add.png' style={{ width: "30px", height: "30px" }} />
            <span>Add to platform</span></p>

          {/* manages */}

          <div onMouseEnter={() => setManage("doctor")} onMouseLeave={() => setManage("")}
            style={{ transition: "0.3s ease", fontSize: "16px", backgroundColor: "#cccacaff", padding: "1px", borderRadius: "6px", color: "#071e47ff", width: "90%", display: "flex", flexDirection: "column", gap: "4px", cursor: "pointer" }}>
            <p
              style={{ fontSize: "16px", backgroundColor: "#cccacaff", padding: "8px", borderRadius: "6px", fontWeight: "700", color: "#071e47ff", width: "100%", display: "flex", gap: "4px", alignItems: "center", cursor: "pointer" }}>
              <img src='/Assets/location.png' style={{ width: "20px", height: "20px" }} />
              <span> Hospital manage</span>
             
               <img src='/Assets/right.png' style={{
                width: "20px",
        height: "14px",
        marginLeft: "auto",
    transition: "transform 0.3s ease",
    transform: manage === "doctor" ? "rotate(90deg)" : "rotate(0deg)"
  }} />
            </p>
             
            <div style={{ transition: "0.6s ease ", padding: 0, margin: 0,maxHeight: manage === "doctor" ? "120px" : "0px",
opacity: manage === "doctor" ? 1 : 0,
transform: manage === "doctor" ? "translateY(0)" : "translateY(-6px)",
overflow: "hidden",
transition: "all 0.35s ease", }}>
              <p className='!font-medium !hover:font-bold hover:text-red-300' onClick={() => navigate("/find-hospitals")} style={{ fontSize: "14px", paddingLeft: "30px" }}>Search Hospitals --{'>'}</p>
              <p onClick={() => navigate("/view-hospitals")} style={{ fontSize: "14px", paddingLeft: "30px" }}>Our Hospitals --{'>'}</p>
            </div>
          </div>

          <div onMouseEnter={() => setManage("diagnostic")} onMouseLeave={() => setManage("")}
            style={{ fontSize: "16px", backgroundColor: "#cccacaff", padding: "0px", borderRadius: "6px", fontWeight: "700", color: "#071e47ff", width: "90%", display: "flex", flexDirection: "column", gap: "4px", cursor: "pointer" }}>
            <p
              style={{ fontSize: "16px", backgroundColor: "#cccacaff", padding: "8px 3px", borderRadius: "6px", fontWeight: "700", color: "#071e47ff", width: "100%", display: "flex", gap: "4px", alignItems: "center", cursor: "pointer" }}>
              <img src='/Assets/health.png' style={{ width: "20px", height: "20px" }} />
              <span>Diagnostic manage</span>
                <img src='/Assets/right.png' style={{
                width: "20px",
        height: "14px",
        marginLeft: "auto",
    transition: "transform 0.3s ease",
    transform: manage === "diagnostic" ? "rotate(90deg)" : "rotate(0deg)"
  }} />
            </p>
           <div style={{ transition: "0.2 sec ", padding: 0, margin: 0 ,maxHeight: manage === "diagnostic" ? "120px" : "0px",
opacity: manage === "diagnostic" ? 1 : 0,
transform: manage === "diagnostic" ? "translateY(0)" : "translateY(-6px)",
overflow: "hidden",
transition: "all 0.35s ease",}}>
              <p onClick={() => navigate("/find-diagonistics")} style={{ fontWeight: "400", fontSize: "14px", paddingLeft: "30px" }}>Search Diagnostics --{'>'}</p>
              <p onClick={() => navigate("/view-diagonistics")} style={{ fontWeight: "400", fontSize: "14px", paddingLeft: "30px" }}>Our Diagnostics --{'>'}</p>
            </div>
          </div>

          <div onMouseEnter={() => setManage("patient")} onMouseLeave={() => setManage("")}
            style={{ fontSize: "16px", backgroundColor: "#cececeff", padding: "0px", borderRadius: "6px", color: "#071e47ff", width: "90%", display: "flex", gap: "4px", flexDirection: "column", cursor: "pointer" }}>
            <p onClick={() => navigate("/patients")}
              style={{ fontSize: "16px", backgroundColor: "#cececeff", padding: "8px", borderRadius: "6px", fontWeight: "700", color: "#071e47ff", width: "100%", display: "flex", alignItems: "center", gap: "4px", cursor: "pointer" }}>
              <img src='/Assets/add-user.png' style={{ width: "20px", height: "20px" }} />
              <span>Patients manage</span>
                <img src='/Assets/right.png' style={{
                width: "20px",
        height: "14px",
        marginLeft: "auto",
    transition: "transform 0.3s ease",
    transform: manage === "patient" ? "rotate(90deg)" : "rotate(0deg)"
  }} />
            </p>
            <div style={{ transition: "0.2 sec ", padding: 0, margin: 0,maxHeight: manage === "patient" ? "120px" : "0px",
opacity: manage === "patient" ? 1 : 0,
transform: manage === "patient" ? "translateY(0)" : "translateY(-6px)",
overflow: "hidden",
transition: "all 0.35s ease", }}>
              <p className='!font-medium !hover:font-bold hover:text-red-300' onClick={() => navigate("/find-doctors")} style={{ fontSize: "14px", paddingLeft: "30px" }}>Pateint data upload --{'>'}</p>
              <p onClick={() => navigate("/patients")} style={{ fontSize: "14px", paddingLeft: "30px" }}>Our Patients--{'>'}</p>
            </div></div>

          <p style={{ fontSize: "16px", backgroundColor: "#cececeff", padding: "8px", borderRadius: "6px", fontWeight: "700", color: "#071e47ff", width: "fit-content", display: "flex", gap: "4px", alignItems: "center", cursor: "pointer" }}>
            <img src='/Assets/add-user.png' style={{ width: "20px", height: "20px" }} />
            <span>Track You Data</span>
            <img src='/Assets/right.png' style={{ width: "20px", height: "14px" }} />
          </p>

          <p onClick={() => {
            dispatch(logout());
            navigate("/")
          }}
            style={{ fontSize: "16px", backgroundColor: "#000000ff", padding: "8px", borderRadius: "6px", fontWeight: "700", color: "#ffffffff", width: "fit-content", display: "flex", gap: "4px", alignItems: "center", cursor: "pointer", bottom: "10px", position: "absolute" }}>
            <img src='/Assets/turn-off.png' style={{ width: "20px", height: "20px", backgroundColor: "white", padding: "2px", borderRadius: "50%" }} />
            <span>Log Out</span>
            <img src='/Assets/right.png' style={{ width: "20px", height: "14px" }} />
          </p>
        </div>

        {/* MAIN CONTENT AREA */}
        <div style={{ width: "80%", height: "100%", maxHeight: "fit-content", overflow: "auto" }}>
           <div style={{ position: "relative", width: "100%", height: "50%", borderRadius: "10px" }}>
            
            {/* NEW IMAGE */}
            <img src='/assets/doc-dash21.png' style={{ borderRadius: "10px", width: "100%", height: "100%", objectFit: "cover" }} />
            
            {/* OVERLAY SECTION - NO BLUE BACKGROUND */}
            <div style={{
              position: "absolute",
              left: "10px",
              height: "80%",
              // backgroundColor: "#3166f8ff", // REMOVED BLUE BACKGROUND as requested
              width: "60%",
              top: "24px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "30px"
            }}>
              
              <p style={{ fontSize: "34px", fontWeight: "700", color: "white", textShadow: "0 2px 5px rgba(0,0,0,0.5)" }}>
                Welcome to DashBoard Doctor
              </p>
              
              <div style={{ display: "flex", alignItems: "center", justifyContent: "left", gap: "20px" }}>
                {/* WHITE BUTTONS (Restored/Checked) */}
                <div onClick={() => navigate("/request")}
                  style={{ position: "relative", display: "flex", alignItems: "center", width: "120px", gap: "10px", padding: "8px", borderRadius: "8px", backgroundColor: "#fefefe", cursor: "pointer", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
                  <img src='/Assets/hospital-1.png' style={{ width: "30px", height: "30px" }} />
                  <p style={{ fontSize: "14px", fontWeight: "600", width: "50%" }}>Hospital's Request</p>
                  <p style={{
                    padding: "3px", borderRadius: "50%", color: "white", backgroundColor: "#4e0505ff", fontSize: "10px", width: "16px", height: "16px",
                    display: "flex", alignItems: 'center', justifyContent: "center", position: "absolute", top: -3, right: "0"
                  }}>3</p>
                </div>


                <div onClick={() => navigate("/request")}
                  style={{ position: "relative", display: "flex", alignItems: "center", width: "130px", gap: "10px", padding: "8px", borderRadius: "8px", backgroundColor: "#fefefe", cursor: "pointer", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
                  <img src='/Assets/hospital.png' style={{ width: "30px", height: "30px" }} />
                  <p style={{ fontSize: "14px", fontWeight: "600", width: "50%" }}>Diagnostic's Request</p>
                  <p style={{
                    padding: "3px", borderRadius: "50%", color: "white", backgroundColor: "#4e0505ff", fontSize: "10px", width: "16px", height: "16px",
                    display: "flex", alignItems: 'center', justifyContent: "center", position: "absolute", top: -3, right: "0"
                  }}>3</p>
                </div>

              </div>

            </div>
          </div>

          <div style={{ position: "relative", width: "90%", height: "50%", display: "flex",marginLeft:"20px", alignItems: "center", justifyContent: 'space-between',gap:"16px" }}>
            <div style={{ width: "50%", display: "flex", flexWrap: "wrap", overflowY: "auto", overflowX: "hidden", height: "450px", marginTop: "180px" }}>
              <div style={{ width: '100%', height: "200px", backgroundColor: "white", borderRadius: "10px", padding: "20px" }}>
                <h3>Patient Admissions (Daily, Weekly, Monthly, Yearly)</h3>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="admissions" fill="#163158ff" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>



            <div style={{ width: "50%", height: "550px", display: "flex", flexDirection: "column", gap: '20px' }}>
              <div style={{
                width: "100%", height: "300px", marginTop: "120px", padding: "30px", borderRadius: "10px",
                backdropFilter: "blur(10px)",       // blur effect
                backgroundColor: "white", // transparent background (20% white)
                WebkitBackdropFilter: "blur(20px)",
              }}>
                <h3 style={{ fontWeight: "700" }}>Monthly Profit, Expenses and Patient Admissions</h3>

                <ResponsiveContainer>
                  <LineChart data={data2} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />

                    {/* Profit Line */}
                    <Line type="monotone" dataKey="profit" stroke="#007bff" strokeWidth={3} />

                    {/* Expenses Line */}
                    <Line type="monotone" dataKey="expenses" stroke="#ff7f0e" strokeWidth={3} />

                    {/* Patients Line */}
                    <Line type="monotone" dataKey="patients" stroke="#28a745" strokeWidth={3} />
                  </LineChart>
                </ResponsiveContainer>
              </div>

              
            </div>




          </div>

        </div>
      </section>

    </div>
  );
}

export default Dashboard;
